import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.quizQuestion.fields.id'),
  },
  {
    name: 'quizId',
    label: i18n('entities.quizQuestion.fields.quizId'),
  },
  {
    name: 'name',
    label: i18n('entities.quizQuestion.fields.name'),
  },
  {
    name: 'answerType',
    label: i18n('entities.quizQuestion.fields.answerType'),
  },
  {
    name: 'orderInList',
    label: i18n('entities.quizQuestion.fields.orderInList'),
  },
  {
    name: 'archived',
    label: i18n('entities.quizQuestion.fields.archived'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'archivedBy',
    label: i18n('entities.quizQuestion.fields.archivedBy'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'archivedAt',
    label: i18n('entities.quizQuestion.fields.archivedAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.quizQuestion.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.quizQuestion.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
